import { render, staticRenderFns } from "./AllRemittanceadvertisingManagementadd.vue?vue&type=template&id=ccb8fdf6&"
import script from "./AllRemittanceadvertisingManagementadd.vue?vue&type=script&lang=js&"
export * from "./AllRemittanceadvertisingManagementadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports